var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"OrderService"},[_c('ld-header',{attrs:{"fixed":""}},[_vm._v("\n    免责声明\n  ")]),_c('mescroll-vue',{ref:"mescroll",attrs:{"down":_vm.down}},[_c('div',{staticClass:"content"},[_c('pre',{staticClass:"pre-wrap gray",staticStyle:{"padding":"8px"},domProps:{"innerHTML":_vm._s(_vm.content)}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }